import React, { useEffect, useRef, useState } from 'react';
import io from 'socket.io-client';
import swal from 'sweetalert2';
import moment from 'moment';
import logo from '../assets/images/logo.png';
import {ternUser, ternPassword} from "../env.json";
import { getMeetDetailForClient } from './api/scheduledAPI';

const imgUrl = 'https://metromatrix.s3.ap-south-1.amazonaws.com/Public/MetroMatrix/Content/';


const VideoCallClient = () => {

    const [meet,                setMeet]                = useState(null);
    const [callStarted,         setCallStarted]         = useState(false);

    const [isCameraEnabled,     setIsCameraEnabled]     = useState(true);
    const [isMicEnabled,        setIsMicEnabled]        = useState(true);
    const [selectedCamera,      setSelectedCamera]      = useState('user');

    const [socket,              setSocket]              = useState(null);
    const [remoteStream,        setRemoteStream]        = useState(null);
    const localVideoRef                                 = useRef(null);
    const remoteVideoRef                                = useRef(null);
    const peerConnectionRef                             = useRef(null);
    const localStreamRef                                = useRef(null);
    const callStartedRef                                = useRef(callStarted);
    const isFirstRender                                 = useRef(true);

    const queryParameters                               = new URLSearchParams(window.location.search);
    const roomId                                        = queryParameters.get("room");

    const path =  window.location.hostname === 'localhost'?'http://localhost:8080':(`${window.location.protocol}//console.metromatrixonlineconsultation.com/`);

    useEffect(() => {

        fetchDetails();

        const newSocket = io(path, { transports: ['websocket'], withCredentials:true });        

        newSocket.on('connect', ()=> {
            newSocket.emit('client-connected', { socketID: newSocket.id, roomID: roomId, reconnecting: callStartedRef.current })
        });

        setSocket(newSocket);

        newSocket.on('room-full-client', () => {
            setTimeout(() => {
                swal.fire({ 
                    icon: "warning", 
                    text: "Oops! This link is already in use", 
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });
            }, 1000);
        });

        newSocket.on('request-received', (socketId) => {
            swal.fire({
                title: "<small>Would you like to join the call?</small>",
                showCancelButton: true,
                confirmButtonText: "Join",
                cancelButtonText: 'Not now',
                customClass: {
                    confirmButton: "btn btn-primary me-3",
                    cancelButton: "btn btn-secondary"
                },
                buttonsStyling: false
              }).then((result) => {
                if (result.isConfirmed) {
                    newSocket.emit('request-accepted', { socketID: socketId, roomID: roomId });                  
                }
              });
        });

        newSocket.on('init-web-rtc-client', () => {
            setCallStarted(true);
        });

        return () => newSocket.disconnect();
    }, []);

    useEffect(() => {
        callStartedRef.current = callStarted;
        try {
            if (callStarted) {
                swal.fire({
                    titleText           : 'Loading',
                    text                : 'Please Wait...',
                    showConfirmButton   : false,
                    allowOutsideClick   : false,
                    didOpen: () => {
                        swal.showLoading();
                    }
                });
                const peerConnection = new RTCPeerConnection({
                    iceServers: [
                        { urls: 'stun:stun.l.google.com:19302' },
                        {
                            urls: 'turn:13.126.91.230:3478',
                            username: ternUser,
                            credential: ternPassword,
                        },
                    ],
                });
    
                peerConnectionRef.current = peerConnection;
    
                peerConnection.onicecandidate = (event) => {
                    if (event.candidate) {
                        socket.emit('signal', {
                            roomId,
                            candidate: event.candidate,
                        });
                    }
                };
    
                peerConnection.ontrack = (event) => {
                    if (event.streams && event.streams[0]) {
                        setRemoteStream(event.streams[0]);
                    } else {
                        console.error("No streams found on track event.");
                    }
                };
    
                socket.on('signal', async (data) => {
                    if (data.answer) {
                        swal.close();
                        await peerConnection.setRemoteDescription(new RTCSessionDescription(data.answer));
                    }
        
                    if (data.candidate) {
                        await peerConnection.addIceCandidate(new RTCIceCandidate(data.candidate));
                    }
                });
    
                socket.on('location-request', async () => {    
                    captureLocation();        
                });

                socket.on('end-stream', async () => {    
                    await fetchDetails();
                    setCallStarted(false);                    
                });

                socket.on('call-disconnected', async () => {   
                    peerConnection.close(); 
                    setMeet({IsCallDone: 'Y'});
                    setCallStarted(false);                   
                });
    
                const initMediaStream = async () => {
                    try {
                        const constraints = {
                            video: { facingMode: selectedCamera },
                            audio: true
                        };
                        const stream = await navigator.mediaDevices.getUserMedia(constraints);
                        localStreamRef.current = stream;             
        
                        // Add tracks to the peer connection
                        await Promise.all(
                            stream.getTracks().map((track) =>
                                peerConnectionRef.current.addTrack(track, stream)
                            )
                        );

                        if (localVideoRef.current) {
                            localVideoRef.current.srcObject = stream;
                        }

                        setTimeout( async () => {
                            const offer = await peerConnection.createOffer();
                            await peerConnection.setLocalDescription(offer);
                            socket.emit('signal', { roomId, offer });
                        }, 1000);

                    } catch (err) {
                        swal.fire({ 
                            icon: "warning", 
                            text: "Please grant camera and microphone permissions to the browser and reload the page to proceed.", 
                            confirmButtonText: "Reload",
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.reload();
                            }
                        });
                    }
                };
    
                initMediaStream();      
                
                socket.on('connection-interrupted', () => {
                    if (callStarted) {
                        // setTimeout(() => {
                        //     swal.fire({ 
                        //         icon: "warning", 
                        //         text: "Your connection has been interrupted. Please reload the page to restart the call.", 
                        //         confirmButtonText: "Reload",
                        //         allowOutsideClick: false,
                        //         allowEscapeKey: false
                        //     }).then((result) => {
                        //         if (result.isConfirmed) {
                        //             window.location.reload();
                        //         }
                        //     });
                        // }, 1000);
                    }else{
                        window.location.reload();
                    }
                });

                socket.on('renegotiate', () => {
                    renegotiateConnection();
                });

                socket.on('call-restarted', () => {
                    window.location.reload();
                });

                const renegotiateConnection = async () => {
                    try {     
                        await replaceStaleTracks();
                        const offer = await peerConnection.createOffer({ iceRestart: true });
                        await peerConnection.setLocalDescription(offer);
                        socket.emit('signal', { roomId, offer });                 
                    } catch (error) {
                        swal.fire({
                            icon: "warning",
                            title: "Error during renegotiation:",
                            showConfirmButton: false,
                            timer: 1500
                        });
                    }
                };

                const replaceStaleTracks = async () => {
                    try {
                        const constraints = {
                            video: { facingMode: selectedCamera },
                            audio: true
                        };
                        const newStream = await navigator.mediaDevices.getUserMedia(constraints);

                        const senders = peerConnection.getSenders();
                
                        senders.forEach((sender) => {
                            if (sender.track) {
                                // Replace video track
                                if (sender.track.kind === "video") {
                                    const newVideoTrack = newStream.getVideoTracks()[0];
                                    if (newVideoTrack) {
                                        sender.replaceTrack(newVideoTrack);
                                    }
                                }
                
                                // Replace audio track
                                if (sender.track.kind === "audio") {
                                    const newAudioTrack = newStream.getAudioTracks()[0];
                                    if (newAudioTrack) {
                                        sender.replaceTrack(newAudioTrack);
                                    }
                                }
                            }
                        });
                    } catch (error) {
                        console.error("Error replacing tracks:", error);
                        throw error;
                    }
                };

                peerConnection.oniceconnectionstatechange = async () => {
                    if (peerConnection.iceConnectionState === 'failed') {
                        await replaceStaleTracks();
                        const offer = await peerConnection.createOffer({ iceRestart: true });
                        await peerConnection.setLocalDescription(offer);
                        socket.emit('signal', { roomId, offer });
                    }
                };


                window.addEventListener('offline', () => {
                    swal.fire({
                        titleText           : 'Reconnecting',
                        text                : 'Please Wait...',
                        showConfirmButton   : false,
                        allowOutsideClick   : false,
                        didOpen: () => {
                            swal.showLoading();
                        }
                    });
                });
        
                window.addEventListener('online', () => {
                    swal.close();                                 
                });
    
            }
        } catch (error) {
            swal.fire({ 
                icon: "warning", 
                text: "Oops! Something went wrong while processing your request. Please try reloading the page and trying again.", 
                confirmButtonText: "Reload",
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
            return; 
        }

        if (callStarted) {
            document.body.style.backgroundColor = '#000000c9';
        } else {
            document.body.style.backgroundColor = '';
        }
        return () => {
            document.body.style.backgroundColor = '';
        };


    }, [callStarted]);

    useEffect(() => {
        if (remoteStream && remoteVideoRef.current) {
            remoteVideoRef.current.srcObject = remoteStream;
        }
    }, [remoteStream]);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false; // Skip first render
            return;
        }
        startCamera(selectedCamera);
        return () => {
            if (localStreamRef.current) {
                localStreamRef.current.getVideoTracks().forEach((track) => track.stop());
            }
        };
    }, [selectedCamera]);

    const startCamera = async (camera = "user") => {
        try {
            const newVideoStream  = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: camera }
            });

            const newVideoTrack = newVideoStream.getVideoTracks()[0];

            const oldAudioTrack = localStreamRef.current.getAudioTracks()[0];
            const newStream = new MediaStream([newVideoTrack, oldAudioTrack]);

            localStreamRef.current = newStream;
            if (localVideoRef.current) {
                localVideoRef.current.srcObject = newStream;
            }

            // Replace video track in WebRTC peer connection
            const senders = peerConnectionRef.current.getSenders();
            const videoSender = senders.find((sender) => sender.track && sender.track.kind === "video");

            if (videoSender) {
                videoSender.replaceTrack(newVideoTrack);
            }
        } catch (error) {
            console.error("Error accessing camera:", error);
        }
    };

    const fetchDetails = async() => {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
             const { Meet } = await getMeetDetailForClient(roomId);
             setMeet(Meet);
            swal.close();
        } catch (err) {
            swal.close();
            swal.fire({ 
                icon: "warning", 
                title: "<small>Oops.. this link is not valid!</small>", 
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            return;  
        }
    }

    const toggleCamera = () => {
        if (localStreamRef.current) {
            const videoTrack = localStreamRef.current.getVideoTracks()[0];
            if (videoTrack) {
                videoTrack.enabled = !videoTrack.enabled;
                setIsCameraEnabled(videoTrack.enabled);
            }
        }
    };

    const toggleMic = () => {
        if (localStreamRef.current) {
            const audioTrack = localStreamRef.current.getAudioTracks()[0];
            if (audioTrack) {
                audioTrack.enabled = !audioTrack.enabled;
                setIsMicEnabled(audioTrack.enabled);
            }
        }
    };

    const flipCamera = () => {
        setSelectedCamera((prev) => (prev === 'user' ? 'environment' : 'user'));
    };


    const captureLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    socket.emit('send-location', { roomId, location: { latitude, longitude } });
                    swal.fire({
                        icon: 'success',
                        title: '<small>Location captured successfully!</small>',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                },
                (error) => {
                    let errorMessage = "";
    
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            errorMessage = "You have denied the location request. Please allow location access in your browser settings.";
                            break;
                        case error.POSITION_UNAVAILABLE:
                            errorMessage = "Unable to retrieve your location. Please try again.";
                            break;
                        case error.TIMEOUT:
                            errorMessage = "The request to get your location timed out. Please try again.";
                            break;
                        default:
                            errorMessage = `Error capturing location: ${error.message}`;
                    }
    
                    swal.fire({
                        icon: "warning",
                        text: errorMessage,
                        showCancelButton: true,
                        confirmButtonText: "Check Permissions",
                        cancelButtonText: "Continue",
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            try {
                                // Check for location permission status and prompt again if allowed
                                const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });
                                if (permissionStatus.state === 'granted') {  
                                    // If permissions have changed, retry capturing the location
                                    captureLocation();
                                } else {
                                    swal.fire({
                                        icon: "warning",
                                        text: "Please enable location access in your browser settings.",
                                    });
                                }
                            } catch (err) {
                                swal.fire({
                                    icon: "warning",
                                    text: "Error checking permissions"
                                });
                            }
                        }
                    });
                }
            );
        } else {
            swal.fire({
                icon: "warning",
                text: "Geolocation is not supported by this browser."
            });
        }
    };
    

    return (
        <>
            <div className='container-fluid' style={{ backgroundColor: `${callStarted ? '#000000c9' : '#fff'}` }}>
                {(meet && meet.IsCallDone == 'N' && !callStarted) && (
                    <div className="row justify-content-center align-items-center text-center" style={{ height: '100vh' }}>
                        <div className="col-12">
                            <div className='login-logo margin-t0'>
                                <img width="234" height="88" src={logo} alt="Metro Matrix Online Consultation"/>
                            </div>
                            <h3>Video Medical With</h3>
                            <div className="d-flex justify-content-center align-items-center mt-5 mb-3">
                                {meet.DoctorPhoto && meet.DoctorPhoto !== '' ? (
                                    <img 
                                        src={`${imgUrl}${meet.DoctorPhoto}`} 
                                        alt="Doctor" 
                                        className="rounded-circle" 
                                        width="70" 
                                        height="70" 
                                    />
                                ) : (
                                    <div className="initial-circle-tpa d-flex justify-content-center align-items-center rounded-circle bg-success text-white" style={{ width: '70px', height: '70px' }}>
                                        {meet.DoctorName[0]}
                                    </div>
                                )}
                            </div>
                            <h5>Dr. {meet.DoctorName}</h5>
                            <span className="fs-16 fw-semibold d-block mb-3" style={{ color: '#767676' }}>
                                <i className="bi bi-clock-fill me-2" style={{ color: '#4582ec' }}></i>
                                {moment(meet.Date).format('DD MMM')} {meet.From} - {meet.To}
                            </span>
                            <span>You will receive a video call request from Dr. {meet.DoctorName} shortly. Please ensure you are ready to join the session.</span>
                        </div>
                    </div>
                )}

                {(meet && meet.IsCallDone == 'Y') && (
                    <div className='container-fluid'>
                        <div className="row justify-content-center align-items-center text-center" style={{ height: '100vh' }}>
                            <div className="col-12">
                                <div className='login-logo margin-t0'>
                                    <img width="234" height="88" src={logo} alt="Metro Matrix Online Consultation"/>
                                </div>
                                <h3>Your video medical has been successfully submitted</h3>
                                <div className="d-flex justify-content-center align-items-center mt-4 mb-3">
                                    <div className="initial-circle-tpa d-flex justify-content-center align-items-center rounded-circle bg-success text-white" style={{ width: '70px', height: '70px' }}>
                                        <i className='bi bi-check-lg'></i>
                                    </div>
                                </div>
                                <h4>Thank you!</h4>
                            </div>
                        </div>
                    </div>
                )}

                {callStarted && (
                     <div className="row" style={{ height: '100%' }} >
                        <div className='col-12 mt-2 pnlVideoCall'>
                            <div className='row'>
                                <div className='col-12 clientFrame'>
                                    <video className="remoteVideoFrame" ref={remoteVideoRef} autoPlay playsInline />
                                    <video className="localVideoFrame" ref={localVideoRef} autoPlay playsInline muted />
                                    <div className="controls d-flex justify-content-between">
                                        <button className="btnControl" onClick={toggleCamera}>
                                            <i className={`bi ${isCameraEnabled ? 'bi-camera' : 'bi-camera-video-off'}`}></i>
                                        </button>
                                        <button className="btnControl" onClick={toggleMic}>
                                            <i className={`bi ${isMicEnabled ? 'bi-mic' : 'bi-mic-mute'}`}></i>
                                        </button>
                                        <button className="btnControl" onClick={flipCamera}>
                                            <i className="bi bi-arrow-repeat"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                
            </div>

            <style jsx="true">{`

                body {
                    overflow: hidden;
                }

                /* Mobile Responsiveness */
                @media (max-width: 1024px) {
                    .clientFrame {
                        height: 86vh !important;
                        width: 98% !important;
                    }
                    .clientFrame .localVideoFrame {
                        height: 15% !important;
                    }
                }

                @media (max-width: 450px) {
                    .clientFrame .localVideoFrame {
                        left: 75% !important;
                    }
                }

                @media (min-width: 451px) and (max-width: 1024px) {
                    .clientFrame .localVideoFrame {
                        left: 85% !important;
                    }
                }

                @media (min-width: 1025px) {
                    .clientFrame .remoteVideoFrame {
                        height: 98vh !important;
                        width: 60% !important;
                        left: 10% !important;
                    }

                    .pnlVideoCall .controls {
                        left: 40% !important;
                    }
                }

                @media (min-width: 1025px) and (min-height: 1020px) {
                    .pnlVideoCall .controls {
                        bottom: 22% !important;
                    }
                }

                @media (min-width: 1025px) and (min-height: 801px) and (max-height: 850px) {
                    .pnlVideoCall .controls {
                        bottom: 28% !important;
                    }
                }

                @media (min-width: 1025px) and (max-width: 1115px) and (max-height: 1019px) {
                    .pnlVideoCall .controls {
                        bottom: 37% !important;
                    }
                }

                @media (min-width: 1116px) and (max-width: 1920px) and (max-height: 800px) {
                    .pnlVideoCall .controls {
                        bottom: 50% !important;
                    }
                }

                @media (min-width: 1500px) and (max-width: 1920px) and (min-height: 800px) {
                    .pnlVideoCall .controls {
                        bottom: 48% !important;
                    }
                }

            `}</style>

        </>
        
    );
};

export default VideoCallClient;
